module.exports = __webpack_public_path__ + "img/orange-triangle.b22ddfce.svg";